import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { AccountService } from '../../core/services/account.service';
import { catchError, map } from 'rxjs/operators';
import { CoreLib } from '../models/core-lib';
import * as fromShell from '../../core/reducers/shell.reducer';
import { Store, select } from '@ngrx/store';
import { ShellActions } from '../../core/actions';

declare var core: CoreLib;
declare var baseUrl: string;
declare var baseApiUrl: string;

@Injectable({
  providedIn: 'root'
})
export class AuthenticatedGuard implements CanActivate {
  constructor(private accountService: AccountService, private router: Router, private store: Store<fromShell.ShellState>) { }


  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    const url = state.url;

    this.store.dispatch(new ShellActions.SetProcessing(true));

    return this.accountService.loggedIn().pipe(
      map(success => {
        if (!success) {
          const returnUrl = encodeURIComponent(`${baseUrl}#${url}`);
          window.location.href = `${baseUrl}Account/Login?returnUrl=${returnUrl}`;
        }
        this.store.dispatch(new ShellActions.GetLoggedInStatusSuccess());
        return success;
      }
      ));
  }
}

@Injectable({
  providedIn: 'root'
})
export class UnauthenticatedGuard implements CanActivate {
  constructor(private accountService: AccountService, private router: Router, private store: Store<fromShell.ShellState>) { }


  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (next.routeConfig.path == "profiles") {//currently unnecessary since this guard is only used on profiles route
      const regexExp = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
      const baseProfileurl = "/profiles/";
      var urlLength = state.url.length;
      if (next.children[0].routeConfig.children[0].path == ":profileId") {
        var profileId = state.url.substring(baseProfileurl.length, urlLength).replace('/', '');
        if (profileId.length > 0 && !regexExp.test(profileId)) { //is profile id not in correct guid format
          /*trying to get 404 page to load gave me a http error and had a spinner, so I'm just redirecting to profiles index */
          setTimeout(() => this.router.navigateByUrl('profiles'/*, { skipLocationChange: true }*/));
        }
      }
    }
    return true;
  }
}
